if (!customElements.get('pickup-availability')) {
  customElements.define(
    'pickup-availability',
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();

        if (!this.hasAttribute('available')) return;

        this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);
        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.fetchAvailability(this.dataset.variantId);
      }

      fetchAvailability(variantId) {
        if (!variantId) return;

        let rootUrl = this.dataset.rootUrl;
        if (!rootUrl.endsWith('/')) {
          rootUrl = rootUrl + '/';
        }
        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

        fetch(variantSectionUrl)
          .then((response) => response.text())
          .then((text) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('.shopify-section');
            this.renderPreview(sectionInnerHTML);
          })
          .catch((e) => {
            const button = this.querySelector('button');
            if (button) button.removeEventListener('click', this.onClickRefreshList);
            this.renderError();
          });
      }

      onClickRefreshList() {
        this.fetchAvailability(this.dataset.variantId);
      }

      update(variant) {
        if (variant?.available) {
          this.fetchAvailability(variant.id);
        } else {
          this.removeAttribute('available');
          this.innerHTML = '';
        }
      }

      updateCollectionDate() {
        const label = this.querySelector('[data-pickup-collection-date]');
        if (!label) return;

        const cutoffHour = 15; // 3 pm. Change to 16 for 4 pm.

        // Add public holidays and other closures as YYYY-MM-DD.
        const closedDates = new Set([
          // '2026-12-25',
        ]);

        const parts = new Intl.DateTimeFormat('en-AU', {
          timeZone: 'Australia/Perth',
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          hour: 'numeric',
          hourCycle: 'h23',
        }).formatToParts(new Date());

        const values = Object.fromEntries(
          parts.map(({ type, value }) => [type, value])
        );

        // UTC is used only as a calendar container for Perth's date.
        const today = new Date(Date.UTC(
          Number(values.year),
          Number(values.month) - 1,
          Number(values.day)
        ));
        const collectionDate = new Date(today);

        const dateKey = (date) => date.toISOString().slice(0, 10);
        const isPickupDay = (date) => {
          const weekday = date.getUTCDay();
          return weekday !== 0 &&
            weekday !== 6 &&
            !closedDates.has(dateKey(date));
        };

        const sameDay =
          isPickupDay(today) && Number(values.hour) < cutoffHour;

        if (!sameDay) {
          collectionDate.setUTCDate(collectionDate.getUTCDate() + 1);
        }

        while (!isPickupDay(collectionDate)) {
          collectionDate.setUTCDate(collectionDate.getUTCDate() + 1);
        }

        const formattedDate = new Intl.DateTimeFormat('en-AU', {
          timeZone: 'UTC',
          day: '2-digit',
          month: 'long',
        }).format(collectionDate);

        const cutoffLabel = cutoffHour === 15 ? '3:00 pm' : '4:00 pm';

        label.textContent = sameDay
          ? `Order before ${cutoffLabel} to collect in-store Today, ${formattedDate}*`
          : `Collect in-store ${formattedDate}*`;
      }

      renderError() {
        this.innerHTML = '';
        this.appendChild(this.errorHtml);

        this.querySelector('button').addEventListener('click', this.onClickRefreshList);
      }

      renderPreview(sectionInnerHTML) {
        const drawer = document.querySelector('pickup-availability-drawer');
        if (drawer) drawer.remove();
        if (!sectionInnerHTML.querySelector('pickup-availability-preview')) {
          this.innerHTML = '';
          this.removeAttribute('available');
          return;
        }

        this.innerHTML = sectionInnerHTML.querySelector('pickup-availability-preview').outerHTML;
        this.setAttribute('available', '');
        this.updateCollectionDate();

        document.body.appendChild(sectionInnerHTML.querySelector('pickup-availability-drawer'));
        const colorClassesToApply = this.dataset.productPageColorScheme.split(' ');
        colorClassesToApply.forEach((colorClass) => {
          document.querySelector('pickup-availability-drawer').classList.add(colorClass);
        });

        const button = this.querySelector('button');
        if (button)
          button.addEventListener('click', (evt) => {
            document.querySelector('pickup-availability-drawer').show(evt.target);
          });
      }
    }
  );
}

if (!customElements.get('pickup-availability-drawer')) {
  customElements.define(
    'pickup-availability-drawer',
    class PickupAvailabilityDrawer extends HTMLElement {
      constructor() {
        super();

        this.onBodyClick = this.handleBodyClick.bind(this);

        this.querySelector('button').addEventListener('click', () => {
          this.hide();
        });

        this.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });
      }

      handleBodyClick(evt) {
        const target = evt.target;
        if (
          target != this &&
          !target.closest('pickup-availability-drawer') &&
          target.id != 'ShowPickupAvailabilityDrawer'
        ) {
          this.hide();
        }
      }

      hide() {
        this.removeAttribute('open');
        document.body.removeEventListener('click', this.onBodyClick);
        document.body.classList.remove('overflow-hidden');
        removeTrapFocus(this.focusElement);
      }

      show(focusElement) {
        this.focusElement = focusElement;
        this.setAttribute('open', '');
        document.body.addEventListener('click', this.onBodyClick);
        document.body.classList.add('overflow-hidden');
        trapFocus(this);
      }
    }
  );
}

